import { createContext, useContext, useEffect, useState, ReactNode } from "react";

interface ExchangeRatesContextType {
  exchangeRates: Record<string, number> | null;
  loading: boolean;
}

const ExchangeRatesContext = createContext<ExchangeRatesContextType | undefined>(undefined);

export function ExchangeRatesProvider({ children }: { children: ReactNode }) {
  const [exchangeRates, setExchangeRates] = useState<Record<string, number> | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchExchangeRates = async () => {
      try {
        const response = await fetch("https://api.exchangerate-api.com/v4/latest/USD");

        if (!response.ok) {
          throw new Error("Failed to fetch exchange rates");
        }

        const data = await response.json();

        setExchangeRates({
          USD: 1,
          MXN: data.rates.MXN,
          EUR: data.rates.EUR,
        });
      } catch {
        setExchangeRates(null);
      } finally {
        setLoading(false);
      }
    };

    void fetchExchangeRates();
  }, []);

  return (
    <ExchangeRatesContext.Provider value={{ exchangeRates, loading }}>
      {children}
    </ExchangeRatesContext.Provider>
  );
}

export function useExchangeRatesContext() {
  const context = useContext(ExchangeRatesContext);
  if (context === undefined) {
    throw new Error("useExchangeRatesContext must be used within an ExchangeRatesProvider");
  }
  return context;
}
